import { __DEV__ } from "@framework/config";
import { trans } from "@mongez/localization";

export function parseError(error: any) {
  if (__DEV__) {
    console.log(error);
  }

  if (error?.response) {
    error = error.response;
  }

  if (!error) {
    return error;
  }

  if ([405, 500, 401].includes(error.status)) {
    return trans("error.somethingWentWrong");
  }

  if (error.status === 404) {
    return trans("notFound");
  }

  if (error?.data?.errors) {
    error = error.data.errors;
  }

  if (error?.data?.error) {
    error = error.data.error;
  }

  if (error instanceof Error) {
    error = error.message;
  }

  if (
    typeof error === "string" &&
    /feature .*not included|not included in (the )?(current|your) plan/i.test(
      error,
    )
  ) {
    return trans("ratings.featureNotIncludedTitle");
  }

  let errorContent: any;

  if (Array.isArray(error)) {
    errorContent = error.map((error: any) => {
      if (error.value || error.error) {
        return <div key={error.key}>{error.value || error.error}</div>;
      }

      return error;
    });
  } else {
    errorContent = error;
  }

  return errorContent;
}
